<template>
  <div class="vuse-content-wrapper">
    <div v-if="hasAccess('schedule')">
      <vuse-section-definition
        :title="`Schedule`"
        icon="mdi-calendar-month"
      ></vuse-section-definition>

      <AvailableUsers />
      <v-container fluid class="">
        <v-card :loading="loading">
          <v-card-title class="d-flex justify-space-around">
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex">
              <v-col @click="newTask()" v-show="hasAccess('schedule.add')">
                <v-btn outlined class="mr-2" block color="info">
                  <v-icon>add</v-icon> Schedule
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  outlined
                  block
                  class="mr-2"
                  color="grey darken-2"
                  @click="setToday"
                >
                  Today
                </v-btn>
              </v-col>
              <v-col>
                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      outlined
                      color="grey darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>Day</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>Week</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>Month</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-if="hasAccess('schedule.edit') && type !== 'month'">
                <v-switch
                  v-model="editable"
                  label="Draggable mode"
                  :disabled="loading"
                />
              </v-col>

              <v-col>
                <v-text-field
                  v-model="keyword"
                  label="Search Calendar"
                  clearable
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="600" v-if="!keyword">
                  <v-calendar
                    ref="calendar"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :type="type"
                    :interval-height="50"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @click:event="showEvent"
                    @change="updateRange"
                    @mousedown:event="startDrag"
                    @mousedown:time="startTime"
                    @mousemove:time="mouseMove"
                    @mouseup:time="endDrag"
                    @mouseleave.native="cancelDrag"
                  >
                    <template v-slot:event="{ event, timed, timeSummary }">
                      <div class="v-event-draggable" style="cursor: move">
                        <v-row>
                          <v-col
                            cols="12"
                            class="d-flex justify-content-between"
                          >

                          <div>
                              <v-menu offset-y v-if="false">
                                <template v-slot:activator="{ on }">
                                  <v-btn dark v-on="on" x-small icon>
                                    <v-icon>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item @click="editEvent(event)" dense>
                                    <v-list-item-title> Edit</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    @click="deleteEvent(event)"
                                    v-if="
                                      event &&
                                      typeof event.id == 'undefined' &&
                                      !event.saved
                                    "
                                    dense
                                  >
                                    <v-list-item-title>
                                      Cancel</v-list-item-title
                                    >
                                  </v-list-item>
                                  <v-list-item
                                    @click="saveEvent(event)"
                                    dense
                                    v-if="
                                      event &&
                                      event.id &&
                                      !event.saved &&
                                      editable
                                    "
                                  >
                                    <v-list-item-title> Save</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                            <!-- <div
                              style="margin: 2px 5px"
                              v-if="event.employees.length > 0"
                            >
                              <UsersChip
                                v-for="employee in event.employees"
                                :key="employee.id"
                                :value="[
                                  {
                                    userId: employee.id,
                                    userFirstName: employee.firstName,
                                    userLastName: employee.lastName,
                                  },
                                ]"
                                size="25"
                              />
                            </div> -->
                            <div
                              style="margin: 2px 0px; user-select: none;"
                              v-if="
                                typeof event.id === 'undefined' || !event.saved
                              "
                              class="d-flex flex-column"
                            >
                              <span style="font-style: italic">Unsaved</span>
                              <span>{{ timeSummary() }}</span>
                            </div>
                            <div v-else style="margin: 2px 5px">
                              {{ event.originalName }} - {{ 
                                event.isAllDay 
                                ? '6AM - 2:30PM'
                                : timeSummary() }}
                            </div>
                          </v-col>
                        </v-row>
                        <div
                          v-if="timed && editable"
                          class="v-event-drag-bottom"
                          @mousedown.stop="extendBottom(event)"
                        ></div>
                      </div>
                    </template>
                  </v-calendar>
                </v-sheet>

                <v-sheet v-else>
                  Search Result of "{{ keyword }}"
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="calendarHeaders"
                        :items="events"
                        class="elevation-1"
                        :loading="loading"
                        :item-class="itemRowBackground"
                        :disable-pagination="true"
                      >
                        <template v-slot:item.userId="{ item }">
                          <UsersChip
                            v-if="item.taskUsers && item.taskUsers.length > 0"
                            :value="item.taskUsers"
                          />
                        </template>

                        <template v-slot:item.name="{ item }">
                          <v-btn @click="switchFocus(item)" x-small>{{
                            item.name
                          }}</v-btn>
                        </template>

                        <template v-slot:item.startdate="{ item }">
                          <v-chip x-small>{{
                            item.startdate | formatDatetime
                          }}</v-chip>
                          <v-chip x-small v-show="item.endDate">{{
                            item.endDate | formatDatetime
                          }}</v-chip>
                        </template>

                        <template v-slot:item.action="{ item }">
                          <v-menu offset-y v-if="editable">
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" x-small icon>
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="editEvent(item)" dense>
                                <v-list-item-title> Edit</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="deleteEvent(item)"
                                v-if="
                                  item &&
                                  typeof item.id == 'undefined' &&
                                  !item.saved
                                "
                                dense
                              >
                                <v-list-item-title> Cancel</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="saveEvent(item)"
                                dense
                                v-if="
                                  item && item.id && !item.saved && editable
                                "
                              >
                                <v-list-item-title> Save</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>

      <TaskDialogScheduling
        :show="selectedOpenScheduling"
        :item="selectedEvent"
        @onClosed="clearTask()"
        @onSucceded="refreshCalendar()"
        @onCanceled="refreshCalendar()"
        @onScheduleDeleted="deleteJob"
      />

      <TaskDialogScheduling
        :show="selectedOpen"
        :item="selectedEvent"
        @onClosed="clearTask()"
        @onSucceded="refreshCalendar()"
        @onScheduleDeleted="deleteJob"
      />
    </div>
    <NoPermission v-else />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import TaskDialogScheduling from "src/views/Pages/Task/_FormSchedule";
import formatterMixin from "@/mixins/formatterMixin";
import AvailableUsers from "src/views/Pages/Dashboard/_AvailableUsers";
import UsersChip from "components/UsersChip";
import store from "src/store";
import NoPermission from "components/NoPermission";

const defaultHeaders = [
  { text: "Action", value: "action", sortable: false, active: true },
  { text: "Name", value: "name", sortable: true, active: true },
  {
    text: "Clients",
    align: "start",
    sortable: true,
    value: "client",
    active: true,
  },
  { text: "Assigned To", value: "userId", active: true },
  { text: "Status", value: "status", sortable: true, active: true },
  {
    text: "Description",
    value: "description",
    sortable: true,
    active: true,
  },
  { text: "Date", value: "startDate", sortable: true, active: true },
];

export default {
  mixins: [formatterMixin],
  components: {
    TaskDialogScheduling,
    UsersChip,
    AvailableUsers,
    NoPermission,
  },
  data: () => ({
    calendarHeaders: defaultHeaders,
    editable: false,
    loading: false,
    focus: new Date(),
    keyword: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    selectedOpenScheduling: false,
    events: [],
    colors: "#a59b9b",
    dragEvent: null,
    dragEventOld: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
  }),

  mounted() {
    this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      task: (state) => state.schedule.data,
      account: (state) => state.account.data.user,
    }),
  },
  watch: {
    async keyword(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        await this.refresh({ SearchTerm: newValue });
      }
    },

    type(n) {
      if(n === "week" || n === "day") {
        // calling this in $nextTick as a workaround
        // see: https://github.com/vuetifyjs/vuetify/issues/12473
        this.$nextTick(() => {
          this.$refs.calendar.scrollToTime('08:00');
        })
      }
    }
  },
  methods: {
    ...mapActions({
      clearTask: "task/clearTask",
      taskGetAll: "schedule/getAll",
      taskUpdate: "schedule/update",
    }),
    switchFocus(item) {
      this.focus = this.formatDatetime(item.startDate);
      this.keyword = "";
      this.type = "day";
    },

    itemRowBackground(item) {
      return item.color;
    },

    async newTask() {
      // ensure task in store is reset before adding new schedule
      await this.clearTask();

      let initDate = this.focus;

      // if date is in yyyy-mm-dd string format, convert to date object
      if (this.focus && this.focus.length === 10) {
        initDate = new Date(this.focus.replace(/-/g,'/'));
      }

      // regardless of what day is focused, base time off current local time
      const initDateTime = this.dateCurTime(initDate);
      
      const hour = 1000 * 60 * 60;
      const startMs = this.roundTime(initDateTime.getTime(), true);
      const startDate = this.localToUtc(new Date(startMs));
      const endDate = this.localToUtc(new Date(startMs + hour));

      this.addTask({
        startDate: startDate,
        endDate: endDate,
        status: "open",
      });
    },

    refreshCalendar() {
      const { lastEnd, lastStart } = this.$refs.calendar;
      this.$refs.calendar.$emit("change", {
        start: lastStart,
        end: lastEnd,
      });
    },
    async refresh(payload) {
      this.loading = true;
      await this.taskGetAll({
        ...payload,
      });

      this.events = [];
      this.task
        .filter((task) => {
          if (!this.hasAccess("schedule.view")) {
            return this.account && task.employeeId === this.account.id;
          } else {
            return true;
          }
        })
        .map((task) => {
          const isAllDay = !!task?.isAllDay;
          const start = this.formatCalendarDatetime(task.startDate, isAllDay);
          const end = this.formatCalendarDatetime(task.endDate, isAllDay);
          
          this.events.push({
            ...task,
            originalName: task.taskName,
            color: task?.color || task?.taskColor || this.colors,
            timed: 1,
            start: start,
            end: end,
            saved: true,
            savedStatus: "Saved",
            allDay: task?.isAllDay
          });
        });
      this.loading = false;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    clearTask() {
      this.selectedEvent = {};
      this.selectedOpen = false;
      this.selectedOpenScheduling = false;
    },
    addTask(initialValue = {}, show = true) {
      this.selectedEvent = initialValue;
      this.selectedOpen = show;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    editEvent(event) {
      this.selectedEvent = event;
      this.selectedOpenScheduling = true;
    },

    saveEvent(event) {
      store
        .dispatch("task/update", {
          task: {
            ...event,
            date: event.startDate.replace(" ", "T") + "Z",
            endDate: event.endDate.replace(" ", "T") + "Z",
          },
          id: event.id,
        })
        .then(() => {
          let i = this.events.indexOf(event);
          this.events[i].saved = true;
        });
    },

    deleteJob(event) {
      this.events = this.events.filter(function (item) {
        return item.id !== event.id;
      });
    },

    deleteEvent(event) {
      if (
        window.confirm("are you sure you want to cancel this job schedule?")
      ) {
        const i = this.events.indexOf(event);
        if (i !== -1) {
          this.events.splice(i, 1);
        }
      }
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = { ...event, name: event.originalName };
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpenScheduling = true;
        }, 10);
      };
      if (typeof event.id !== "undefined") {
        if (this.selectedOpenScheduling) {
          this.selectedOpenScheduling = false;
          setTimeout(open, 10);
        } else {
          open();
        }
      }

      nativeEvent.stopPropagation();
    },
    async updateRange({ start, end }) {
      let payload = {
        startDate: this.momentLocal(start.date)
          .subtract(2, "day")
          .utc()
          .format("YYYY-MM-DD"),
        endDate: this.momentLocal(end.date)
          .add(2, "day")
          .utc()
          .format("YYYY-MM-DD"),
        PageSize: 1000,
      };
      await this.refresh(payload);
    },
    rnd() {
      return "#FFCCFF";
    },

    startDrag({ event, timed }) {
      if (event && timed && this.editable) {
        console.log("starting drag!");
        this.dragEvent = event;
        this.dragEventOld = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },
    startTime(tms) {
      if (!this.editable) {
        return false;
      }
      const mouse = this.roundTime(this.toTime(tms));
      // in dragging mode
      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start;
        this.dragTime = mouse - start;
      } else if (this.hasAccess("schedule.add")) {
        this.createStart = this.roundTime(this.toTime(tms));
        let halfHour = 1000 * 30 * 60;
        let createEnd = this.createStart + halfHour;

        this.createEvent = {
          XX: tms.date,
          originalName: `Unsaved Schedule`,
          color: this.colors,
          startDate: this.localToUtc(new Date(this.createStart)).format(
            process.env.VUE_APP_DATETIME_FORMAT
          ),
          endDate: this.localToUtc(new Date(createEnd)).format(
            process.env.VUE_APP_DATETIME_FORMAT
          ),
          start: this.createStart,
          end: createEnd,
          timed: 1,
          status: "open",
          saved: false,
          employees: [],
          taskUsers: [],
        };
        let foundNotSave = this.events.filter(i => !i.saved);
        if (foundNotSave.length == 0) {
          this.events.push(this.createEvent);
        } else {
          alert("Unsaved schedule already exists")
        }
      }
    },

    extendBottom(event) {
      this.createEvent = event;
      this.createStart = event.start;
      this.extendOriginal = event.end;
    },

    /**
     * @param tms Date object
     */
    mouseMove(tms) {
      const mouse = this.roundTime(this.toTime(tms));
      if (this.dragEvent && this.dragTime !== null) {
        let start = this.dragEvent.start;
        let end = this.dragEvent.end;

        if (typeof start !== "number") {
          start = new Date(start).getTime();
        }

        if (typeof end !== "number") {
          end = new Date(end).getTime();
        }

        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = newStartTime;
        const newEnd = newStart + duration;
        this.dragEvent.start = newStart;
        this.dragEvent.end = newEnd;
        this.dragEvent.startDate = this.localToUtc(new Date(newStart)).format(
          process.env.VUE_APP_DATETIME_FORMAT
        );
        this.dragEvent.endDate = this.localToUtc(new Date(newEnd)).format(
          process.env.VUE_APP_DATETIME_FORMAT
        );

        this.dragEvent.saved = false;
        this.dragEvent.savedStatus = "Not saved";
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded =  this.roundTime(mouse);

        let createStart = this.createStart;
        if (typeof createStart !== "number") {
          this.createStart = new Date(createStart).getTime();
        }

        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.start = min;
        if (min !== max) {
          this.createEvent.end = max;
        }

        this.createEvent.startDate = this.localToUtc(new Date(min)).format(
          process.env.VUE_APP_DATETIME_FORMAT
        );
        this.createEvent.endDate = this.localToUtc(new Date(max)).format(
          process.env.VUE_APP_DATETIME_FORMAT
        );
        this.createEvent.saved = false;
        this.createEvent.savedStatus = "Not saved";
      }
    },
    endDrag() {
      // if drag ended after creating an unsaved event, open edit dialog
      const unsavedEvent = this.events.find(x => !x.saved);
      if (unsavedEvent) {
        this.editEvent(unsavedEvent)
      }

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
    },
    cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
    },

    // round int timestamp to nearest quarter hour
    roundTime(ms, forceRoundUp = false) {
      let timeToReturn = new Date(ms);
      timeToReturn.setMilliseconds(Math.round(timeToReturn.getMilliseconds() / 1000) * 1000);
      timeToReturn.setSeconds(Math.round(timeToReturn.getSeconds() / 60) * 60);
      timeToReturn.setMinutes(Math.round(timeToReturn.getMinutes() / 15) * 15);

      if(forceRoundUp && timeToReturn.getTime() < Date.now()) {
        timeToReturn.setMinutes(timeToReturn.getMinutes() + 15);
      }

      return timeToReturn.getTime();
    },

    /**
     * @return int timestamp
     */
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },

    // returns given date at current local time
    dateCurTime(date) {
      const now = new Date();
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      )
    },

    getEventColor(event) {
      return event.color;
    },
    rndElement(arr) {
      return arr[this.rnd(0, arr.length - 1)];
    },
  },
};
</script>


<style scoped lang="scss">
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}
</style>